// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3_GL1","flat":"button_flat__1gLBD","linkstyling":"button_linkstyling__2_-n4"};